import {ActivityConfig, ActivityStatus, ScoreVO, StatusUtil, TLSafeHtml} from '@transparent/coretypes';

export class ActivityVO {
    activityType: string;
    alphabetURL: string;
    asCorrects = 0;
    backgroundImageUrl = '';
    challenges = 0;
    color: string;
    completionScore = 0;
    config: ActivityConfig;
    correct = 0;
    corrects = 0;
    dataURL: string;
    dataURLs: string[] = [];
    description: string;
    easyType: boolean;
    enabled = true;
    icon: string;
    incorrect = 0;
    incorrects = 0;
    index = -1;
    isAssessment = false;
    isB4u = false;
    isCustom = false;
    isHtml = false;
    isPdf = false;
    isReference = false;
    lessonIndex = -1;
    moduleName: string;
    moduleURL: string;
    maxScore = 0;
    minScore = 0;
    name = '';
    nameSafeHtml: TLSafeHtml;
    numItems = 0;
    numPoints = 0;
    currentPoint = 0;
    percentage = 0;
    position = 0;
    required = false;
    score = 0;
    selected = false;
    showSkill = true;
    showStartScreen = true;
    status = 'not attempted';
    timeSpent = 0;
    total = 0;
    totalPoints = 0;
    uuid = '';
    userAnswers: any = null;
    hasExpandButton = false;
    showTimer = false;
    challengesTime = ''; // "04:00,03:30,02:00,05:00"

    clone(): ActivityVO {
        const vo = new ActivityVO();
        Object.keys(this).forEach((key: string) => {
            vo[key] = this[key];
        });
        return vo;
    }

    /**
     *
     * {string}
     */
    getHelpName(): string {
        return this.moduleURL.substring(this.moduleURL.lastIndexOf('/') + 1, this.moduleURL.lastIndexOf('.'));
    }

    /**
     *
     * {string}
     */
    getIconName(): string {
        return this.moduleURL.substring(this.moduleURL.lastIndexOf('/') + 1, this.moduleURL.lastIndexOf('.')) + 'Icon';
    }

    /**
     *
     * {string}
     */
    getStatus(): string {
        return this.status;
    }

    /**
     *
     * value
     */
    setStatus(value: string): void {
        if ((value !== ActivityStatus.FAILED) && (this.status === ActivityStatus.COMPLETED || this.status === ActivityStatus.PASSED)) {
            return;
        }
        this.status = value;
    }

    /**
     *
     * value
     */
    setScoreVo(value: ScoreVO): void {
        this.position = value.position || 0;
        this.correct = value.correct || 0;
        this.total = value.total || 0;
        this.incorrect = this.total - this.correct;
        this.userAnswers = value.userAnswers;
        this.currentPoint = value.currentPoint;
        this.totalPoints = value.totalPoints;
    }

    /**
     *
     * {ScoreVO}
     */
    getScoreVo(): ScoreVO {
        const svo = new ScoreVO();
        svo.position = this.position;
        svo.correct = this.correct;
        svo.total = this.total;
        svo.totalPoints = this.numPoints;
        svo.currentPoint = this.currentPoint;
        return svo;
    }

    /**
     * {string} value
     */
    setDescription(value: string): void {
        this.description = value || '';
    }

    /**
     *
     * {string}
     */
    getDescription(): string {
        return this.description;
    }

    /**
     *
     * {string}
     */
    toString(): string {
        let statusString: string | any = StatusUtil.statusToInt(this.status);
        // Activity status
        statusString += ':' + this.correct;    // Number of correct answers
        statusString += ':' + this.total;      // Total number of answers
        statusString += ':' + this.position;   // Position of user progress
        statusString += ':' + this.challenges; // Number of Challenges
        // statusString += ':' + this.corrects;   // Number of Correct Answers
        statusString += ':' + this.incorrects; // Number of Incorrect Answers
        statusString += ':' + this.asCorrects; // Number of Accept As Correct
        statusString += ':' + this.timeSpent;  // The time spent with the activity open
        return statusString.split(/NaN|undefined/ig).join('0');
    }

    /**
     * Populates values from saved status in LMS
     * {string} value
     */
    setValuesFromLMS(value: string): void {
        if (!value) {
            return;
        }
        const arr = value.split(':');
        this.setStatus(StatusUtil.intToStatus((+arr[0])));
        this.correct = (+arr[1]) || 0;
        this.total = (+arr[2]) || 0;
        this.position = (+arr[3]) || 0;
        if (this.status === ActivityStatus.COMPLETED) {
            this.percentage = 100;
        }
    }
}
